import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import './Auth.css';

const SERVICES = ['Shaadi', 'Engagement', 'Birthday', 'Rice Ceremony', 'Griha Pravesh', 'Corporate', 'Baby Shower', 'Anniversary'];

const VENDOR_TYPES = [
  { value: 'decorator', label: 'Decorator' },
  { value: 'photographer', label: 'Photographer' },
  { value: 'dj', label: 'DJ' },
  { value: 'makeup_artist', label: 'Makeup Artist' },
  { value: 'mehendi_artist', label: 'Mehendi Artist' },
  { value: 'cake_catering', label: 'Cake & Catering' },
  { value: 'tent_furniture', label: 'Tent & Furniture' },
  { value: 'videographer', label: 'Videographer' },
  { value: 'anchor', label: 'Anchor' },
  { value: 'wedding_car', label: 'Wedding Car' },
];

// Popular cities for datalist suggestions
const SUGGESTED_CITIES = [
  'Raipur', 'Bhilai', 'Durg', 'Rajnandgaon', 'Bilaspur', 'Korba',
  'Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata',
  'Pune', 'Ahmedabad', 'Jaipur', 'Lucknow', 'Bhopal', 'Indore',
  'Nagpur', 'Patna', 'Chandigarh', 'Surat', 'Vadodara', 'Agra',
  'Varanasi', 'Meerut', 'Nashik', 'Aurangabad', 'Faridabad', 'Ghaziabad',
  'Jodhpur', 'Coimbatore', 'Kochi', 'Visakhapatnam', 'Ludhiana',
  'Amritsar', 'Ranchi', 'Guwahati', 'Bhubaneswar', 'Dehradun',
];

export default function Register() {
  const { register, loading } = useAuth();
  const navigate = useNavigate();
  const [role, setRole] = useState('client');
  const [form, setForm] = useState({
    name: '', email: '', phone: '', password: '', city: '',
    businessName: '', description: '', services: [],
    priceMin: '', priceMax: '', experience: '', whatsapp: '', vendorType: 'decorator', specificTag: ''
  });

  const toggleService = (service) => {
    setForm(prev => ({
      ...prev,
      services: prev.services.includes(service)
        ? prev.services.filter(s => s !== service)
        : [...prev.services, service]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone || !form.password || !form.city.trim()) {
      return toast.error('Sab required fields bharo');
    }
    if (role === 'decorator' && form.services.length === 0) {
      return toast.error('Kam se kam ek service select karo');
    }

    const data = {
      name: form.name, email: form.email, phone: form.phone,
      password: form.password, city: form.city.trim(), role,
    };

    if (role === 'decorator') {
      data.businessName = form.businessName || form.name;
      data.description = form.description;
      data.services = form.services;
      data.priceRange = { min: Number(form.priceMin) || 10000, max: Number(form.priceMax) || 50000 };
      data.experience = Number(form.experience) || 0;
      data.whatsapp = form.whatsapp || form.phone;
      data.vendorType = form.vendorType;
      data.specificData = form.specificTag ? { specialTag: form.specificTag } : {};
    }

    const result = await register(data);
    if (result.success) {
      toast.success('Account ban gaya!');
      navigate(role === 'decorator' ? '/decorator/dashboard' : '/decorators');
    } else {
      toast.error(result.message);
    }
  };

  return (
    <div className="auth-page page">
      <div className="auth-card auth-card-wide card">
        <div className="auth-header">
          <div className="auth-logo">🎊</div>
          <h2>Join DecorHub</h2>
          <p>India ke kisi bhi sheher se register karo</p>
        </div>

        {/* Role Toggle */}
        <div className="role-toggle">
          <button
            className={`role-btn ${role === 'client' ? 'active' : ''}`}
            onClick={() => setRole('client')} type="button"
          >
            🎉 Client Hoon
          </button>
          <button
            className={`role-btn ${role === 'decorator' ? 'active' : ''}`}
            onClick={() => setRole('decorator')} type="button"
          >
            🎨 Decorator Hoon
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="grid-2">
            <div className="form-group">
              <label>Poora Naam *</label>
              <input
                className="input"
                placeholder="Ramesh Kumar"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Phone *</label>
              <input
                className="input"
                placeholder="9876543210"
                value={form.phone}
                onChange={e => setForm({ ...form, phone: e.target.value })}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              className="input"
              type="email"
              placeholder="tumhara@email.com"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
            />
          </div>

          <div className="grid-2">
            <div className="form-group">
              <label>Password *</label>
              <input
                className="input"
                type="password"
                placeholder="••••••••"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>City *</label>
              {/* Free text input with suggestions — koi bhi city type kar sakte hain */}
              <input
                className="input"
                list="cities-list"
                placeholder="Apni city type karo..."
                value={form.city}
                onChange={e => setForm({ ...form, city: e.target.value })}
                autoComplete="off"
              />
              <datalist id="cities-list">
                {SUGGESTED_CITIES.map(c => (
                  <option key={c} value={c} />
                ))}
              </datalist>
            </div>
          </div>

          {/* Decorator Extra Fields */}
          {role === 'decorator' && (
            <div className="decorator-fields">
              <div className="decorator-divider">Decorator Details</div>

              <div className="grid-2">
                <div className="form-group">
                  <label>Vendor Type *</label>
                  <select
                    className="input"
                    value={form.vendorType}
                    onChange={e => setForm({ ...form, vendorType: e.target.value })}
                  >
                    {VENDOR_TYPES.map(v => <option key={v.value} value={v.value}>{v.label}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Special Tag (optional)</label>
                  <input
                    className="input"
                    placeholder="Jaise: candid-shoot, bridal-makeup"
                    value={form.specificTag}
                    onChange={e => setForm({ ...form, specificTag: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Business Name</label>
                <input
                  className="input"
                  placeholder="Jaise: Shree Decorations"
                  value={form.businessName}
                  onChange={e => setForm({ ...form, businessName: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  className="input"
                  rows={3}
                  placeholder="Apne kaam ke baare me batao..."
                  value={form.description}
                  onChange={e => setForm({ ...form, description: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>Services (multiple select kar sakte ho) *</label>
                <div className="services-select">
                  {SERVICES.map(s => (
                    <button
                      key={s} type="button"
                      className={`service-tag ${form.services.includes(s) ? 'selected' : ''}`}
                      onClick={() => toggleService(s)}
                    >
                      {s}
                    </button>
                  ))}
                </div>
              </div>

              <div className="grid-2">
                <div className="form-group">
                  <label>Min Price (₹)</label>
                  <input
                    className="input"
                    type="number"
                    placeholder="15000"
                    value={form.priceMin}
                    onChange={e => setForm({ ...form, priceMin: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>Max Price (₹)</label>
                  <input
                    className="input"
                    type="number"
                    placeholder="100000"
                    value={form.priceMax}
                    onChange={e => setForm({ ...form, priceMax: e.target.value })}
                  />
                </div>
              </div>

              <div className="grid-2">
                <div className="form-group">
                  <label>Experience (years)</label>
                  <input
                    className="input"
                    type="number"
                    placeholder="3"
                    value={form.experience}
                    onChange={e => setForm({ ...form, experience: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label>WhatsApp Number</label>
                  <input
                    className="input"
                    placeholder="9876543210"
                    value={form.whatsapp}
                    onChange={e => setForm({ ...form, whatsapp: e.target.value })}
                  />
                </div>
              </div>
            </div>
          )}

          <button
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }}
            disabled={loading}
          >
            {loading ? 'Ban raha hai...' : 'Account Banao'}
          </button>
        </form>

        <p className="auth-footer">
          Pehle se account hai? <Link to="/login">Login karo</Link>
        </p>
      </div>
    </div>
  );
}